export default __webpack_public_path__ + "img/boom.aee8f98c.svg";